import { useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { downloadBlob } from "@/components/roster/shiftColours";
import { placedToast } from "@/components/roster/CopyShiftsDialog";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Upload } from "lucide-react";
import { toast } from "sonner";

export function ShiftImport({ onDone }) {
  const ref = useRef(null);
  const [errors, setErrors] = useState([]);
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try {
      const { data } = await api.post("/roster/shifts/import", fd);
      setErrors(data.errors);
      placedToast(data);
      if (data.errors.length) toast.error(`${data.errors.length} row(s) could not be imported`);
      onDone();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    if (ref.current) ref.current.value = "";
  };
  return (
    <Card className="p-4" data-testid="shift-import">
      <div className="flex flex-wrap items-center gap-3">
        <div className="min-w-[220px] flex-1">
          <p className="text-base font-bold text-slate-900">Bulk import shifts</p>
          <p className="text-sm text-slate-600">Fill the template: Locations = names, ALL, or blank to keep the shift in the Shift library to assign later.</p>
        </div>
        <Button variant="outline" onClick={() => downloadBlob(api, "/roster/shifts/template", "shift_template.xlsx")} data-testid="shift-template-btn"><Download className="mr-1 h-4 w-4" /> Download template</Button>
        <input ref={ref} type="file" accept=".xlsx" className="hidden" onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])} data-testid="shift-import-input" />
        <Button onClick={() => ref.current?.click()} data-testid="shift-import-btn"><Upload className="mr-1 h-4 w-4" /> Import shifts</Button>
      </div>
      {!!errors.length && (
        <div className="mt-3 rounded-lg bg-rose-50 p-3 text-sm text-rose-900" data-testid="shift-import-errors">{errors.map((e) => <p key={e}>{e}</p>)}</div>
      )}
    </Card>
  );
}
